import { checkout as ImtblCheckout, passport as ImtblPassport, config } from '@imtbl/sdk';
import { useEffect, useState } from 'react';

import { notifyError, storefrontType } from '../utils';

export type UseCheckoutClientProps = {
  passport: ImtblPassport.Passport | undefined;
  environment: config.Environment;
};
export const useCheckoutClient = ({ passport, environment }: UseCheckoutClientProps) => {
  const [checkout, setCheckout] = useState<ImtblCheckout.Checkout | undefined>(undefined);
  useEffect(() => {
    if (!passport) return;

    const onRampEnabled = storefrontType !== 'metalcore';
    const swapEnabled = storefrontType !== 'metalcore';

    try {
      const checkoutInstance = new ImtblCheckout.Checkout({
        baseConfig: new config.ImmutableConfiguration({ environment }),
        passport,
        bridge: { enable: true },
        onRamp: { enable: onRampEnabled },
        swap: { enable: swapEnabled }
      });
      setCheckout(checkoutInstance);
    } catch (err) {
      notifyError(err);
    }
  }, [passport, environment]);

  return checkout;
};
